import { useCallback } from 'react';
import { useUploadStore } from 'store/uploadStore';

export const useUploadData = initialId => {
  const { setUploadById, ...uploads } = useUploadStore();

  const getUploadById = useCallback(
    id => {
      return uploads?.[id];
    },
    [uploads]
  );

  const getUpload = useCallback(() => {
    return uploads?.[initialId];
  }, [initialId, uploads]);

  const hasActiveUpload = useCallback(() => {
    const uploadsCopy = {
      ...uploads,
    };

    delete uploadsCopy.getUploadById;
    delete uploadsCopy.setUploadById;

    return Object.values(uploadsCopy).some(i => !!i);
  }, [uploads]);

  const resetUpload = (id = initialId) => setUploadById(id, null);

  const getFormatedFileUploadById = useCallback(
    id => {
      const uploadValue = uploads?.[id];
      const fileValue = uploadValue?.file;

      if (fileValue) {
        fileValue.percent = uploadValue?.percentageValue || 0;
      }
      return fileValue;
    },
    [uploads]
  );

  return {
    getFormatedFileUploadById,
    hasActiveUpload,
    setUploadById,
    getUploadById,
    resetUpload,
    getUpload,
    uploads,
  };
};
